import { basicGet } from '../../../../api/accordanceApi';
import * as config from '../../../../api/config.json';

export const getClauses = (code: string, loanNumber: string) => {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return Promise.reject(new Error('OFFLINE'));
  }

  const safeCode = encodeURIComponent(code);
  const safeLoan = encodeURIComponent(loanNumber).replace(/%2F/g, '/');

  const url = config.GET_INDICATOR_CLAUSES_DATA
    .replace('{code}', safeLoan)
    .replace('{}', safeCode);

  return new Promise<any[]>((resolve, reject) => basicGet(url, resolve, reject));
};
